import { TeamInfo } from './types';

const TEAM_LOGO_BASE = 'https://awesemostorage.blob.core.windows.net/sports/nba/teams';

export const nbaTeams: Record<string, TeamInfo> = {
  // Primary entries using API abbreviations
  ATL: { name: 'Hawks', fullName: 'Atlanta Hawks', abbr: 'ATL', logo: `${TEAM_LOGO_BASE}/ATLH.png` },
  BKN: { name: 'Nets', fullName: 'Brooklyn Nets', abbr: 'BKN', logo: `${TEAM_LOGO_BASE}/BKNN.png` },
  BOS: { name: 'Celtics', fullName: 'Boston Celtics', abbr: 'BOS', logo: `${TEAM_LOGO_BASE}/BOSC.png` },
  CHA: { name: 'Hornets', fullName: 'Charlotte Hornets', abbr: 'CHA', logo: `${TEAM_LOGO_BASE}/CHAH.png` },
  CHI: { name: 'Bulls', fullName: 'Chicago Bulls', abbr: 'CHI', logo: `${TEAM_LOGO_BASE}/CHIB.png` },
  CLE: { name: 'Cavaliers', fullName: 'Cleveland Cavaliers', abbr: 'CLE', logo: `${TEAM_LOGO_BASE}/CLEC.png` },
  DAL: { name: 'Mavericks', fullName: 'Dallas Mavericks', abbr: 'DAL', logo: `${TEAM_LOGO_BASE}/DALM.png` },
  DEN: { name: 'Nuggets', fullName: 'Denver Nuggets', abbr: 'DEN', logo: `${TEAM_LOGO_BASE}/DENN.png` },
  DET: { name: 'Pistons', fullName: 'Detroit Pistons', abbr: 'DET', logo: `${TEAM_LOGO_BASE}/DETP.png` },
  GS: { name: 'Warriors', fullName: 'Golden State Warriors', abbr: 'GS', logo: `${TEAM_LOGO_BASE}/GSWW.png` },
  HOU: { name: 'Rockets', fullName: 'Houston Rockets', abbr: 'HOU', logo: `${TEAM_LOGO_BASE}/HOUR.png` },
  IND: { name: 'Pacers', fullName: 'Indiana Pacers', abbr: 'IND', logo: `${TEAM_LOGO_BASE}/INDP.png` },
  LAC: { name: 'Clippers', fullName: 'Los Angeles Clippers', abbr: 'LAC', logo: `${TEAM_LOGO_BASE}/LACC.png` },
  LAL: { name: 'Lakers', fullName: 'Los Angeles Lakers', abbr: 'LAL', logo: `${TEAM_LOGO_BASE}/LALL.png` },
  MEM: { name: 'Grizzlies', fullName: 'Memphis Grizzlies', abbr: 'MEM', logo: `${TEAM_LOGO_BASE}/MEMG.png` },
  MIA: { name: 'Heat', fullName: 'Miami Heat', abbr: 'MIA', logo: `${TEAM_LOGO_BASE}/MIAH.png` },
  MIL: { name: 'Bucks', fullName: 'Milwaukee Bucks', abbr: 'MIL', logo: `${TEAM_LOGO_BASE}/MILB.png` },
  MIN: { name: 'Timberwolves', fullName: 'Minnesota Timberwolves', abbr: 'MIN', logo: `${TEAM_LOGO_BASE}/MINT.png` },
  NO: { name: 'Pelicans', fullName: 'New Orleans Pelicans', abbr: 'NO', logo: `${TEAM_LOGO_BASE}/NOPP.png` },
  NY: { name: 'Knicks', fullName: 'New York Knicks', abbr: 'NY', logo: `${TEAM_LOGO_BASE}/NYKK.png` },
  OKC: { name: 'Thunder', fullName: 'Oklahoma City Thunder', abbr: 'OKC', logo: `${TEAM_LOGO_BASE}/OKCT.png` },
  ORL: { name: 'Magic', fullName: 'Orlando Magic', abbr: 'ORL', logo: `${TEAM_LOGO_BASE}/ORLM.png` },
  PHI: { name: '76ers', fullName: 'Philadelphia 76ers', abbr: 'PHI', logo: `${TEAM_LOGO_BASE}/PHI7.png` },
  PHX: { name: 'Suns', fullName: 'Phoenix Suns', abbr: 'PHX', logo: `${TEAM_LOGO_BASE}/PHXS.png` },
  POR: { name: 'Trail Blazers', fullName: 'Portland Trail Blazers', abbr: 'POR', logo: `${TEAM_LOGO_BASE}/PORT.png` },
  SA: { name: 'Spurs', fullName: 'San Antonio Spurs', abbr: 'SA', logo: `${TEAM_LOGO_BASE}/SASS.png` },
  SAC: { name: 'Kings', fullName: 'Sacramento Kings', abbr: 'SAC', logo: `${TEAM_LOGO_BASE}/SACK.png` },
  TOR: { name: 'Raptors', fullName: 'Toronto Raptors', abbr: 'TOR', logo: `${TEAM_LOGO_BASE}/TORR.png` },
  UTA: { name: 'Jazz', fullName: 'Utah Jazz', abbr: 'UTA', logo: `${TEAM_LOGO_BASE}/UTAJ.png` },
  WAS: { name: 'Wizards', fullName: 'Washington Wizards', abbr: 'WAS', logo: `${TEAM_LOGO_BASE}/WASW.png` },
  // Aliases for alternative abbreviations
  GSW: { name: 'Warriors', fullName: 'Golden State Warriors', abbr: 'GS', logo: `${TEAM_LOGO_BASE}/GSWW.png` },
  NOP: { name: 'Pelicans', fullName: 'New Orleans Pelicans', abbr: 'NO', logo: `${TEAM_LOGO_BASE}/NOPP.png` },
  NYK: { name: 'Knicks', fullName: 'New York Knicks', abbr: 'NY', logo: `${TEAM_LOGO_BASE}/NYKK.png` },
  PHO: { name: 'Suns', fullName: 'Phoenix Suns', abbr: 'PHX', logo: `${TEAM_LOGO_BASE}/PHXS.png` },
  SAS: { name: 'Spurs', fullName: 'San Antonio Spurs', abbr: 'SA', logo: `${TEAM_LOGO_BASE}/SASS.png` },
};

export function getTeamInfo(abbr: string): TeamInfo {
  return nbaTeams[abbr.toUpperCase()] || {
    name: abbr,
    fullName: abbr,
    abbr: abbr,
    logo: '',
  };
}

// Derive full name to abbreviation mapping from nbaTeams
// Also includes common alternate names (LA Clippers, LA Lakers)
export const NBA_TEAM_NAME_TO_ABBR: Record<string, string> = Object.values(nbaTeams)
  .filter((team, index, self) => self.findIndex(t => t.abbr === team.abbr) === index) // dedupe by abbr
  .reduce((acc, team) => {
    acc[team.fullName] = team.abbr;
    // Add LA variants for Los Angeles teams
    if (team.fullName.startsWith('Los Angeles')) {
      acc[team.fullName.replace('Los Angeles', 'LA')] = team.abbr;
    }
    return acc;
  }, {} as Record<string, string>);
